const floorforceBaseUrl =
  'https://images.floorforce.com/FFCompleteFeatureImages/';
const cloudinaryBaseUrl =
  'https://res.cloudinary.com/force/image/upload/v1682697099/catalog/';

export const FeatureImages = {
  Best_Seller: [`${floorforceBaseUrl}Best-seller.png`],
  Best_Seller_In_Stock: [
    `${floorforceBaseUrl}Best-seller.png`,
    `${floorforceBaseUrl}In-Stock.png`,
  ],
  Buy_Now: [],
  Clearance: [`${floorforceBaseUrl}Clearance.png`],
  Clearance_On_Sale: [
    `${floorforceBaseUrl}Clearance.png`,
    `${floorforceBaseUrl}Sale.png`,
  ],
  Clearance_Sale: [
    `${floorforceBaseUrl}Clearance.png`,
    `${floorforceBaseUrl}Sale.png`,
  ],
  Clearance_On_Sale_Sale: [
    `${floorforceBaseUrl}Clearance.png`,
    `${floorforceBaseUrl}Sale.png`,
  ],
  Clearance_In_Stock: [
    `${floorforceBaseUrl}Clearance.png`,
    `${floorforceBaseUrl}In-Stock.png`,
  ],
  In_Stock: [`${floorforceBaseUrl}In-Stock.png`],
  In_Stock_Clearance: [`${floorforceBaseUrl}Clearance-InStock.gif`],
  In_Stock_Owner_Favorite: [
    `${floorforceBaseUrl}In-Stock.png`,
    `${cloudinaryBaseUrl}owners-favorite.png`,
  ],
  In_Stock_Sale: [`${floorforceBaseUrl}Sale-InStock.gif`],
  New: [`${floorforceBaseUrl}New.png`],
  On_Sale: [],
  Owners_Favorite: [`${cloudinaryBaseUrl}owners-favorite.png`],
  Quick_Ship: [`${floorforceBaseUrl}Quick-Ship.png`],
  Sale: [`${floorforceBaseUrl}Sale.png`],
  Sample_In_Store: [`${floorforceBaseUrl}sample-in-store.png`],
  Special_Order: [`${floorforceBaseUrl}special-order.png`],
  Schedule_Appointment: [],
  Whats_New: [],
} as const;

export type FeatureFlag = keyof typeof FeatureImages;

export const Features = Object.keys(FeatureImages).sort() as FeatureFlag[];
